<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name))"
      icon="mdi-format-list-checks"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="$t(type)"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <v-list-item
            v-if="$store.state.permissions && $store.state.permissions.includes('importExcelInvoice')"
            link
            @click="openUploadDialog"
          >
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0"
            link
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <log
            v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
           
          
          
          
        </v-list>
      </v-menu>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        v-model="selected"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.doc_header.number="{ item }">
          <a
            v-if="item.doc_header"
            @click="openComponent('accountingPrint', item.doc_head_id)"
          >
            {{ item.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
          <v-menu
            offset-y
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="primary"
                class="pl-action-cell__btn"
                v-bind="attrs"
                icon
                x-small
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                link
                :disabled="(item.lock ? true : false)"
                @click="edit(item)"
              >
                <v-list-item-icon>
                  <v-icon class="mt-2">
                    mdi-clipboard-edit
                  </v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        icon
                        small
                        v-on="on"
                        @click.stop.prevent="newTab('ProductEdit', item)"
                      >
                        <v-icon
                          small
                          color="primary"
                        >
                          mdi-content-duplicate
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('newTab') }}</span>
                  </v-tooltip>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="lockPermission"
                link
                @click="lock(item, (item.lock ? 'unlock' : 'lock'))"
              >
                <v-list-item-icon>
                  <v-icon :color="(item.lock ? 'green' : 'pink')">
                    {{ (item.lock ? 'mdi-lock-open-outline' : 'mdi-lock-outline') }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="(item.lock ? $t('unlock') : $t('lock'))" />
              </v-list-item>
              <v-list-item
                link
                @click="turnover(item, null)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-recycle-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('productTurnover')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/' + (typeForm == 'product' ? 'product':'service') +'/edit/' + item.id"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-show="removePermission(type)"
                link
                :disabled="(item.lock ? true : false)"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
          <span class="pl-action-cell__row">
            <a @click="edit(item)">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</a>
          </span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.count="{ item }">
          <v-btn
            class="mx-2"
            dark
            text
            small
            block
            style="padding: 12px 4px !important;justify-content: start"
            color="primary"
            @click="turnover(item, null)"
          >
            {{ item.count }}
          </v-btn>
        </template>
        <template v-slot:item.product.name="{ item }">
          <a
            @click="openComponent('product', item.product_id)"
          >
            {{ item.product.name }}
          </a>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
          <v-icon
            v-if="item.lock"
            color="red"
            style="font-size: 22px"
          >
            mdi-lock-outline
          </v-icon>
        </template>
        <template v-slot:item.name="{ item }">
          <a @click="edit(item)">
            {{ item.name }}
          </a>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t(type)"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo(type)"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <dialog-component
      :dialog-prop="innerComponent"
      :data-prop="dialogData"
      @close="innerComponent = false"
    />
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="productStatus"
              :label="$t('status')"
              :items="productStatusItems"
              height="30"
              dense
              outlined
              multiple
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="inventoryStatus"
              :label="$t('inventoryStatus')"
              :items="inventoryStatusItems"
              height="30"
              dense
              outlined
              clearable
              item-value="value"
              item-text="text"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <tag
              v-model="tag"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="group"
              :title="$t('main-group')"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'group'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat1"
              :title="$t('other-group')"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'category'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="cat2"
              title="category"
              type="productGroup"
              :data="JSON.stringify({parent:null,type:'subcategory'})"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col md="4">
            <autocomplete
              v-model="registerar"
              :title="$t('registerar')"
              type="partners"
              :multiple="true"
              :filter="true"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="selectedHeaders"
              :items="headers"
              label="Select Columns"
              height="30"
              dense
              outlined
              multiple
              return-object
            >
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2"
                  small
                >
                  <span>{{ item.text }}</span>
                </v-chip>
                <v-chip
                  v-if="index === 1"
                  small
                >
                  <span>(+{{ selectedHeaders.length - 2 }} {{ $t('other') }})</span>
                </v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
        <v-card-actions class="px-3">
          <v-row class="ma-0 px-0">
            <v-col
              class="pa-0 py-3"
              cols="6"
            >
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col
              class="pa-0 py-3"
              cols="6"
            >
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
    <v-dialog
      v-model="uploadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="production"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import Upload from '../../components/general/upload/upload'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'ProductionList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      dialogComponent: () => import('../../components/general/dialog/index'),
      Upload,
      Print,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      excelItems: [],
      selected: [],
      pageCount: 1,
      page: 1,
      selectedItem: [],
      inventoryStatus: null,
      inventoryStatusItems: null,
      group: null,
      cat1: null,
      cat2: null,
      registerar: null,
      selectedHeaders: [],
      uploadDialog: false,
      dialogData: false,
      printDialog: false,
      deletDialog: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      type: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      search: null,
    }),
    computed: {
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type === 'production') {
            if (s.value === 'name') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            if (s.value === 'doc_header.number' || s.value === 'entrepot.name' || s.value === 'doc_header.date' || s.value === 'last_status.status_id' || s.value === 'doc_header.number' || s.value === 'tags' || s.value === 'branch.name') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          }
        })
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
    },
    activated () {
      this.getItems()
    },
    beforeMount () {
      if (this.$route.name === 'productionDetailsList') {
        this.type = 'production'
      }
      if (this.$route.name === 'formulaDetailsList') {
        this.type = 'formula'
      }
      this.headers = [
        {
          text: this.$t('#'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 42,
          class: 'pl-action-col',
          cellClass: 'pl-action-col',
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'head_id',
          table: 'production_head.id',
        },
        {
          text: this.$t('date'),
          sortable: false,
          value: 'head.date',
        },
        {
          text: this.$t('formula_name'),
          sortable: true,
          value: 'head.name',
          table: 'production_head.name',
        },
        {
          text: this.$t('production_name'),
          sortable: false,
          value: 'head.product.name',
        },
        {
          text: this.$t('production_count'),
          sortable: false,
          value: 'head.count',
        },
        {
          text: this.$t('consumer_product_service'),
          sortable: false,
          value: 'product.name',
          table: 'products.name',
        },
        {
          text: this.$t('consumer_count'),
          sortable: false,
          value: 'count',
        },
        {
          text: this.$t('entrepot'),
          sortable: false,
          value: 'head.entrepot.name',
        },
        {
          text: this.$t('branch'),
          sortable: false,
          value: 'head.branch.name',
        },
        {
          text: this.$t('content'),
          sortable: false,
          value: 'content',
          table: 'production.content',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'head.user.name',
        },
      ]
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
      this.inventoryStatusItems = [
        {
          value: '>',
          text: this.$t('available'),
        },
        {
          value: '=',
          text: this.$t('unavailable'),
        },
        {
          value: '<',
          text: this.$t('negetive'),
        },
        {
          value: 'orderpoint',
          text: this.$t('orderpoint'),
        },
      ]
      if (this.input) {
        this.model = this.input
      }
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
    },
    mounted () {
    },
    methods: {
      openComponent (component, id) {
        this.dialogData = {
          name: component,
          id: id,
        }
        this.innerComponent = true
      },
      openDeleteDialog (item) {
        this.deleteItem = { id: item.id }
        this.deletDialog = true
      },
      openUploadDialog (item) {
        if (this.$root) {
          this.$root.$emit('open-user-file-process', { type: 'production' })
        }
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        if (item.lock) {
          return false
        }
        this.$router.push({ name: this.type + 'Edit', params: { id: item.id } })
      },
      turnover (item, entrepot) {
        this.$router.push({ name: 'productTurnover', params: { productProp: item.product, entrepotProp: entrepot } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'productionReport', {
          params: {
            select: 'items',
            inventoryStatus: app.inventoryStatus,
            group: app.group,
            cat1: app.cat1,
            cat2: app.cat2,
            registerar: app.registerar,
            search: app.search,
            page: (app.allRows ? app.excelPage : app.options.page),
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            if (!app.allRows) {
              app.items = res.data
              app.totalItems = res.total
              app.pageCount = res.last_page
              app.from = res.from
              app.creatExcelData(res.data)
            } else {
              app.generateExcellForAllData(res.data, res.last_page)
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      lock (item, type) {
        if (this.$store.state.userCurrentPlan != null) {
          const lockItem = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'lockSystem')
          if (lockItem && lockItem.value == 'deactive') {
            this.$store.commit('SET_PLAN_DIALOG', true)
            this.$router.replace('/')
          } else {
            this.selected = [item]
            this.lockGroup(type)
          }
        }
      },
      lockGroup (type) {
        var app = this
        app.loading = true
        var selected = []
        app.selected.map(function (value, key) {
          selected.push(value.id)
        })
        app.$axios.get(this.$endpoint + 'production', {
          params: {
            lock: 'active',
            id: selected,
            type: type,
          },
        })
          .then(res => {
            res = res.data
            app.snakbarText = this.$t('opertationSuccess')
            app.snakbarColor = 'green'
            app.snakbar = true
            app.getItems()
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(function () {
            app.loading = false
            app.selected = []
          })
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'production/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        var object = []
        app.selected.map(function (value, key) {
          object.push({ id: value.id })
        })
        app.$axios.get(this.$endpoint + 'production', {
          params: {
            deleteItems: object,
          },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      creatExcelData (data, type = 'page') {
        var app = this
        if (type === 'page') {
          app.excelItems = []
        }
        data.map(function (d) {
          app.excelItems.push({
            id: d.head_id,
            formula_name: d.head.name,
            type: d.head.type,
            number: d.head.number,
            date: d.head.date,
            production_name: (d.head.product ? d.head.product.name : ''),
            production_id: (d.head.product ? d.head.product.id : ''),
            production_count: d.head.count,
            entrepot_id: (d.head.entrepot ? d.head.entrepot.id : ''),
            entrepot_name: (d.head.entrepot ? d.head.entrepot.name : ''),
            branch: (d.head && d.head.branch ? d.head.branch.name : ''),
            consumer_type: d.product.type,
            consumer_product_name: d.product.name,
            consumer_product_id: d.product.id,
            count: d.count,
            fee: d.fee,
            content: d.content,
          })
        })
      },
    },
  }
</script>
<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
